<template>
	<div class="wrapper">
		<h1>כלים למנהלי האתר</h1>

		<div class="section">
			<h2 class="section-title">עגלות שמורות למתכונים</h2>
			<div v-if="cartPresetsAreLoading">טוען עגלות שמורות...</div>
			<div v-if="!cartPresetsAreLoading">
				<p class="instruction">
					<b>איך זה עובד?</b><br />
					ממלאים עגלה בעמודים באתר בדיוק כמו שלקוח ממלא עגלה.<br />
					במסך הזה בוחרים האם לשמור את העגלה כ״עגלה חדשה״ או לעדכן עגלה שמורה קיימת.<br />
					לאחר ששומרים את העגלה לוחצים על ״להשלמת פרטי עגלה שמורה בממשק הניהול״ ומשלימים בממשק הניהול כותרת
					לפופאפ וטקסט לפופאפ שהלקוחות יראו כשהם יכנסו לקישור.<br />
					בשדה ״קישור ללקוחות״ במסך זה מופיע הקישור שאפשר לתת ללקוחות כדי שיוכלו לטעון את העגלה השמורה להזמנה
					שלהם.
				</p>
				<br />
				<div class="input-container" v-if="cartPresets.length > 0">
					<label for="cart-presets">בחירת עגלה:</label>
					<select id="cart-presets" v-model="selectedCartPresetID">
						<option value="new" selected>עגלה חדשה</option>
						<option v-for="cartPreset in cartPresets" :key="cartPreset.id" :value="cartPreset.id">
							{{ cartPreset.id + " | " + cartPreset.title }}
						</option>
					</select>
				</div>
				<div class="input-container">
					<label for="cart-preset-link">קישור ללקוחות:</label>
					<input id="cart-preset-link" type="text" readonly="true" v-model="selectedCartPresetURL" />
				</div>
				<div class="input-container" v-if="selectedCartPresetID && selectedCartPresetID != 'new'">
					<a :href="wpData.home_url + '/wp-admin/post.php?post=' + selectedCartPresetID + '&action=edit'">
						להשלמת פרטי עגלה שמורה בממשק הניהול
					</a>
				</div>
				<button class="cta loading" :class="{ 'is-loading': savingCartPreset }" @click="saveCartPreset">
					<span class="text">שמירת עגלה</span>
					<span class="loading-text">שמירה מתבצעת...</span>
				</button>
			</div>
		</div>

		<div class="section">
			<RouterLink to="/product-recommendations/">המלצות פרסונליות</RouterLink>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				assets: wpData.assets_url,
				cartPresetsAreLoading: true,
				cartPresets: [],
				savingCartPreset: false,
				cart: this.$store.state.added,
				selectedCartPresetID: "new",
				wpData: wpData,
			};
		},
		computed: {
			user() {
				return this.$store.state.userLoggedInfo;
			},
			selectedCartPreset() {
				if (!this.selectedCartPresetID || this.selectedCartPresetID === "new") {
					return null;
				}
				return this.cartPresets.find((i) => i.id === this.selectedCartPresetID);
			},
			selectedCartPresetURL() {
				if (!this.selectedCartPresetID || this.selectedCartPresetID === "new") {
					return null;
				}
				return wpData.home_url + "?load-cart-preset=" + this.selectedCartPresetID;
			},
		},
		methods: {
			getCarts() {
				fetch(wpData.ajax_url + "?action=ccp_getCarts")
					.then((raw) => raw.json())
					.then((r) => {
						this.cartPresetsAreLoading = false;
						this.cartPresets = r.data;
					});
			},
			saveCartPreset() {
				if (this.savingCartPreset) {
					return false;
				}
				this.savingCartPreset = true;

				const items = [];
				this.cart.forEach((item) => {
					delete item.relatedProducts;
					items.push(item);
				});

				let formData = new FormData();
				formData.append("data", JSON.stringify(items));

				if (this.selectedCartPresetID && this.selectedCartPresetID != "new") {
					formData.append("cart_preset_id", this.selectedCartPresetID);
				}

				fetch(wpData.ajax_url + "?action=ccp_saveCart", {
					method: "POST",
					cache: "no-cache",
					body: formData,
				})
					.then((raw) => raw.json())
					.then((r) => {
						alert("העגלה נשמרה");
						this.selectedCartPresetID = r.data.id;
						this.savingCartPreset = false;
					});
			},
		},
		mounted() {
			// Exit if user is not admin
			if (!this.user || !this.user.isAdmin) {
				this.$router.push({ name: "Home" });
			}

			this.getCarts();
		},
	};
</script>

<style lang="sass" scoped>

	$dark: #25391e
	$main: #1e824c
	$active: #288f57

	h1
		margin-bottom: 3rem

	.wrapper
		padding: 2rem

	.section
		padding: 1.5rem
		background: #fff
		border-radius: 0.5rem
		margin-bottom: 2rem

		.section-title
			margin-bottom: 1.5rem

	.input-container
		margin-bottom: 1rem
		label
			margin-left: 1rem

	.cta
		background: $dark
		color: #fff
		padding: 0.75rem 1rem
		border-radius: 10rem
		overflow: hidden
		cursor: pointer
		&:hover
			background: $main
		&:active
			background: $active
		span
			color: #fff

	.cta.loading.is-loading
		background-color: #9e9e9e
		span.loading-text
			display: block
			color: #6c6c6c
		span.text
			display: none
			color: #6c6c6c
		cursor: not-allowed

	.loading
		span.loading-text
			display: none

	#cart-preset-link
		width: 100%
</style>
